import React from 'react';

interface Props {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const GraphAttachedTooltip = ({children, style}: Props) => (
  <div className="graph-attached-tooltip" style={style}>
    {children}
  </div>
);

export default GraphAttachedTooltip;
